import ProductCmsPage from "components/cms/ProductCmsPage";
import {
  addProductPage,
  getProductPage,
  prepareProductPage,
  updateProductPage,
} from "api/productpage";
import { emptyProducts } from "utils/defaults";

export default function ProductsPage() {
  return (
    <ProductCmsPage
      label="Product one"
      heading="Product one"
      description="/products"
      idPrefix="products-one"
      load={getProductPage}
      create={addProductPage}
      update={updateProductPage}
      empty={emptyProducts}
      prepare={prepareProductPage}
    />
  );
}
